import { helpers } from 'vuelidate/lib/validators';
import { DateTime } from 'luxon';

export default function maxDate(value, date) {
  const givenDate = DateTime.fromISO(DateTime.fromISO(value).toISODate());
  const maxDate = DateTime.fromISO(DateTime.fromISO(date).toISODate());
  return !helpers.req(value) || givenDate <= maxDate;
}
